import *  as _ from "lodash";
import { LeagueRankReward, TournamentReward, TournamentRewardType } from "../models/User";

export interface RewardVisibleIcons {
  collectible: boolean,
  crypto: boolean,
  gems: boolean,
  powerUp: boolean,
}

export function flattenRewardsByRank(rewards:LeagueRankReward[]):TournamentReward[][]{

  let rewardList:TournamentReward[][] = [];
  _.forEach(rewards, function(reward){
    const items = reward.rewards;
    _.forEach(reward.ranks, function(rank){
      rewardList[rank] = items;
    })
  })

  return rewardList;
}

export function computeRewardVisibleIcons(rewards:TournamentReward[]):RewardVisibleIcons {

  let visibleIcons = {
    collectible: false,
    crypto: false,
    gems: false,
    powerUp: false,
  };

  if(!rewards){
    return visibleIcons;
  }

  _.forEach(rewards, function(rewardItem){

    switch (rewardItem.type) {
      case TournamentRewardType.CRYPTO:
        visibleIcons.crypto = true;
        break;
      case TournamentRewardType.GEMS:
        visibleIcons.gems = true;
        break;
      case TournamentRewardType.POWER_UP:
        visibleIcons.powerUp = true;
        break;
      case TournamentRewardType.BRONZE_COLLECTIBLE:
      case TournamentRewardType.SILVER_COLLECTIBLE:
      case TournamentRewardType.GOLD_COLLECTIBLE:
      case TournamentRewardType.PLATINUM_COLLECTIBLE:
      case TournamentRewardType.DIAMOND_COLLECTIBLE:
      case TournamentRewardType.MASTER_COLLECTIBLE:
        visibleIcons.collectible = true;
        break;
      default:
        break;
    }

  })

  return visibleIcons;

}